import { cloneDeep } from 'lodash'

export type IdKey = 'imageGroupEntityId' | 'sampleCode' | 'id' | 'inspirationId'

export default function useMasonryAction<TData = unknown>(setData: React.Dispatch<React.SetStateAction<TData[]>>, idKey?:IdKey | IdKey[]) {
  const onDelete = (id: string | number | (string | number)[]) => {
    if (idKey) {
      if (typeof idKey === 'string') {
        setData(pre => [...pre.filter(m => m[idKey] !== id)])
      } else if (idKey instanceof Array) {
        setData(pre => [...pre.filter(m => {
          const flag = idKey.every((key, index) => m[key] === id[index])
          return !flag
        })])
      }
    }
  }

  const onUpdate = (item) => {
    if (idKey) {
      const _item = cloneDeep(item)
      setData(pre => {
        let curItemIndex
        if (typeof idKey === 'string') {
          curItemIndex = pre.findIndex(m => m[idKey] === item[idKey])
        }
        if (idKey instanceof Array) {
          curItemIndex = pre.findIndex(m => {
            const flag = idKey.every((key) => m[key] === item[key])
            return flag
          })
        }
        if (curItemIndex !== -1) {
          pre[curItemIndex] = { ...pre[curItemIndex], ..._item }
          return [...pre]
        }
        return [...pre]
      })
    }
  }

  return {
    onDelete,
    onUpdate,
  }
}
